import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';

import { LandingService } from '../../api/landing.service';
@UntilDestroy()
@Component({
  selector: 'iv-user-survey',
  templateUrl: './user-survey.component.html',
  styleUrls: ['./user-survey.component.scss']
})
export class UserSurveyComponent implements OnInit {
  private surveyURL: string = `https://survey.alchemer.com/s3/6475643/Finishline-Quarterly-UX-Survey`;
  showMessage: boolean = false;
  constructor(public dialogRef: MatDialogRef<UserSurveyComponent>,
    private landingService: LandingService) { }

  ngOnInit(): void {
    this.userSurveyCallback();
  }

  close() {
    this.landingService.userSurveySubject.next('Maybe-Later');
  }

  openSurvey() {
    this.landingService.userSurveySubject.next('Click Here');
  }

  userSurveyCallback() {
    this.landingService.userSurveyResponseSubject
      .asObservable()
      .pipe(untilDestroyed(this))
      .subscribe(response => {
        if (response) {
          if (response['userSelected'] === 'Maybe-Later'
            && response['apiResponse'] === 'Updated user profile with the response') {
            this.dialogRef.close();
          } else if (response['userSelected'] === 'Click Here'
            && response['apiResponse'] === 'Updated user profile with the response') {
            this.dialogRef.close();
            window.open(this.surveyURL);
          } else if (response['apiResponse'] === 'Cannot Update') {
            this.showMessage = true;
          }
        }
      });
  }

}
